import axios from "axios"

export const getCurrentUser = () => {
  let user = null
  if (typeof window !== "undefined") {
    try {
      user =
        localStorage.getItem("current_user") != null
          ? JSON.parse(localStorage.getItem("current_user"))
          : null
    } catch (error) {
      console.log(
        ">>>>: src/helpers/Utils.js  : getCurrentUser -> error",
        error
      )
      user = null
    }
  }
  return user
}

/**
 * Call-related UI (Call Logs Report, Today/Past call boxes & totals)
 * only for Admin/Sub Admin when CallMan is enabled.
 */
export const canViewCallLogFeatures = () => {
  const user = getCurrentUser()
  if (!user) return false
  const isAdmin =
    user.role_name === "Administrator" ||
    user.role_name === "Sub Administrator" ||
    user.role_id == 1
  return isAdmin && user.allow_callman_app == 1
}

/** Play/download call recordings only when Master has Allow Call Recording on. */
export const canViewCallRecording = () => {
  const user = getCurrentUser()
  if (!user || !canViewCallLogFeatures()) return false
  return user.allow_call_recording == 1
}

/** WhatsApp Business screens show only when Master enabled WhatsApp Meta for this client. */
const metaFlagOn = value => value == 1 || value === true || value === "true"

export const isMetaWhatsappEnabled = () => {
  try {
    const raw = localStorage.getItem("DashboardData")
    if (raw && raw !== "null") {
      const dash = JSON.parse(raw)
      if (
        dash &&
        Object.prototype.hasOwnProperty.call(
          dash,
          "enable_whatsapp_meta_integration"
        )
      ) {
        return metaFlagOn(dash.enable_whatsapp_meta_integration)
      }
    }
  } catch (e) {}
  return metaFlagOn(getCurrentUser()?.enable_whatsapp_meta_integration)
}

export const setCurrentUser = user => {
  if (typeof window !== "undefined") {
    try {
      if (user) {
        localStorage.setItem("current_user", JSON.stringify(user))
      } else {
        localStorage.removeItem("current_user")
      }
    } catch (error) {
      console.log(">>>>: src/helpers/Utils.js : setCurrentUser -> error", error)
    }
  }
}

export const getPermission = () => {
  let user = null
  if (typeof window !== "undefined") {
    try {
      user =
        localStorage.getItem("current_permissions") != null
          ? JSON.parse(localStorage.getItem("current_permissions"))
          : null
    } catch (error) {
      console.log(">>>>: src/helpers/Utils.js  : getPermission -> error", error)
      user = null
    }
  }
  return user
}

export const setPermission = user => {
  if (typeof window !== "undefined") {
    try {
      if (user) {
        localStorage.setItem("current_permissions", JSON.stringify(user))
      } else {
        localStorage.removeItem("current_permissions")
      }
    } catch (error) {
      console.log(">>>>: src/helpers/Utils.js : setPermission -> error", error)
    }
  }
}

export const getFilterDate = () => {
  let user = null
  if (typeof window !== "undefined") {
    try {
      user =
        localStorage.getItem("filter_dates") != null
          ? JSON.parse(localStorage.getItem("filter_dates"))
          : null
    } catch (error) {
      console.log(">>>>: src/helpers/Utils.js  : getFilterDate -> error", error)
      user = null
    }
  }
  return user
}

export const setFilterDate = user => {
  if (typeof window !== "undefined") {
    try {
      if (user) {
        localStorage.setItem("filter_dates", JSON.stringify(user))
      } else {
        localStorage.removeItem("filter_dates")
      }
    } catch (error) {
      console.log(">>>>: src/helpers/Utils.js : setFilterDate -> error", error)
    }
  }
}

export const getFilterDate2 = () => {
  let user = null
  if (typeof window !== "undefined") {
    try {
      user =
        localStorage.getItem("filter_dates2") != null
          ? JSON.parse(localStorage.getItem("filter_dates2"))
          : null
    } catch (error) {
      console.log(
        ">>>>: src/helpers/Utils.js  : getFilterDate2 -> error",
        error
      )
      user = null
    }
  }
  return user
}

export const setFilterDate2 = user => {
  if (typeof window !== "undefined") {
    try {
      if (user) {
        localStorage.setItem("filter_dates2", JSON.stringify(user))
      } else {
        localStorage.removeItem("filter_dates2")
      }
    } catch (error) {
      console.log(">>>>: src/helpers/Utils.js : setFilterDate2 -> error", error)
    }
  }
}

// Send WhatsApp Message
export const sendWhatsAppMessage = (phone, message) => {
  //  add 91 to phone if phone does not start with 91 and phoen length is 10
  if (phone && phone.length === 10) phone = `91${phone}`

  // if message is undefined
  if (message === undefined)
    return `https://web.whatsapp.com/send?phone=${phone}`

  return `https://web.whatsapp.com/send?phone=${phone}&text=${message}`
}

// Mask Email Address
export const maskEmail = email => {
  if (!email) return "***@***.com"

  const [localPart, domain] = email.split("@")
  if (!domain) return "***@***.com"

  // Mask local part: show first char + ***** for each segment
  let maskedLocal = ""
  if (localPart.includes(".")) {
    const localSegments = localPart.split(".")
    maskedLocal = localSegments
      .map(segment => {
        if (segment.length <= 1) return segment
        return segment[0] + "*****"
      })
      .join(".")
  } else {
    maskedLocal = localPart[0] + "*****"
  }

  // Keep domain as is (no masking)
  return `${maskedLocal}@${domain}`
}

/**
 * Followup Lead Tag dropdown + Dashboard Custom Report.
 * Add a portal (company_name / subdomain) here to enable both.
 * Any portal not in this list will not see these features.
 */
export const LEAD_TAG_FEATURE_PORTALS = ["kreative", "demo", "sai", "test"]

export const isLeadTagFeaturePortal = () => {
  const portal = String(localStorage.getItem("company_name") || "").toLowerCase()
  return LEAD_TAG_FEATURE_PORTALS.some(
    name => String(name).toLowerCase() === portal
  )
}

/**
 * Staff page tabs: Staff Management + Groups Management.
 * Other portals only see the Staff list (no tab bar / Groups).
 */
export const STAFF_GROUP_TABS_PORTALS = ["demo", "sai", "amplec", "test"]

export const isStaffGroupTabsPortal = () => {
  const portal = String(localStorage.getItem("company_name") || "").toLowerCase()
  return STAFF_GROUP_TABS_PORTALS.some(
    name => String(name).toLowerCase() === portal
  )
}

export const getLeadTagName = tagId => {
  try {
    const tags = JSON.parse(localStorage.getItem("AllTags") || "[]")
    return tags.find(tag => String(tag.id) === String(tagId))?.name || ""
  } catch (error) {
    return ""
  }
}

const hasValue = value => value !== null && value !== undefined && value !== ""

const pickLeadValue = (current, fallback, key) => {
  if (hasValue(current?.[key])) return current[key]
  if (hasValue(fallback?.[key])) return fallback[key]
  return ""
}

const toLeadApiDate = value => {
  if (!hasValue(value)) return ""
  const text = String(value).trim()
  if (/^\d{4}-\d{2}-\d{2}/.test(text)) return text.slice(0, 10)
  const dmy = text.match(/^(\d{2})-(\d{2})-(\d{4})/)
  if (dmy) return `${dmy[3]}-${dmy[2]}-${dmy[1]}`
  return ""
}

const toLeadLabelIds = lead => {
  if (Array.isArray(lead?.lead_label_id) && lead.lead_label_id.length) {
    return lead.lead_label_id
  }
  if (Array.isArray(lead?.lead_label)) {
    return lead.lead_label.map(item => item.id).filter(hasValue)
  }
  return []
}

/**
 * Update only lead tag_id. Always GET the latest lead first and PUT the
 * existing fields back so assignment/source/address/etc. are not wiped.
 */
export const updateLeadTag = async (leadId, tagId, lead = {}) => {
  if (!leadId || tagId === undefined || tagId === null || tagId === "") {
    return null
  }

  const company = localStorage.getItem("company_name")
  const headers = {
    "content-type": "application/json",
    Authorization: `Bearer ${getCurrentUser()?.token || ""}`,
  }
  const url = `${process.env.REACT_APP_API_URL}/${company}/lead/${leadId}`
  const normalizedTagId = isNaN(Number(tagId)) ? tagId : Number(tagId)

  let current = null
  try {
    const getRes = await axios.get(url, { headers })
    if (getRes.data?.status && getRes.data?.data) {
      current = getRes.data.data
    }
  } catch (error) {
    current = null
  }

  // Never PUT from stale list-card data. Followup already sends tag_id.
  if (!current || typeof current !== "object") {
    return null
  }

  const leadholderId =
    current.leadholder_id ??
    current.leadholder?.id ??
    lead.leadholder_id ??
    lead.leadholder?.id

  const payload = {
    name: pickLeadValue(current, lead, "name"),
    email: pickLeadValue(current, lead, "email"),
    firm_name: pickLeadValue(current, lead, "firm_name"),
    number: pickLeadValue(current, lead, "number"),
    alternate_number: pickLeadValue(current, lead, "alternate_number"),
    alternate_country_code: pickLeadValue(
      current,
      lead,
      "alternate_country_code"
    ),
    lead_source_id: pickLeadValue(current, lead, "lead_source_id"),
    country_name: pickLeadValue(current, lead, "country_name"),
    state: pickLeadValue(current, lead, "state"),
    district: pickLeadValue(current, lead, "district"),
    working_area: pickLeadValue(current, lead, "working_area"),
    country_code: pickLeadValue(current, lead, "country_code"),
    city: pickLeadValue(current, lead, "city"),
    pin_code: pickLeadValue(current, lead, "pin_code"),
    monthly_target: pickLeadValue(current, lead, "monthly_target"),
    flag: current.flag ?? lead.flag ?? "0",
    lead_label_id: toLeadLabelIds(current).length
      ? toLeadLabelIds(current)
      : toLeadLabelIds(lead),
    proforma_address: pickLeadValue(current, lead, "proforma_address"),
    deliver_to: pickLeadValue(current, lead, "deliver_to"),
    branch_id: current.branch_id ?? lead.branch_id ?? "",
    best_time: pickLeadValue(current, lead, "best_time"),
    dob: toLeadApiDate(current.dob || lead.dob),
    anniversary: toLeadApiDate(current.anniversary || lead.anniversary),
    important_date: toLeadApiDate(
      current.important_date || lead.important_date
    ),
    tag_id: normalizedTagId,
  }

  if (hasValue(leadholderId)) {
    payload.leadholder_id = leadholderId
  }

  const res = await axios.put(url, payload, { headers })
  if (res.data?.status) {
    return res.data
  }
  const error = new Error(res.data?.message || "Failed to update lead tag")
  error.apiMessage = res.data?.message
  throw error
}
